import { FormattedText } from '../types/banner/formatted-text';

export const isFormattedText = (value: unknown): value is FormattedText => {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return typeof v.text === 'string' && typeof v.html === 'string';
};

export const isFileObject = (value: unknown): value is { file: File } => {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return v.file instanceof File;
};
